export const fetchAllExportRecords = async (dataProvider, resource, params) => {
  const records = [];
  let page = 1;
  const perPage = 1000;

  while (true) {
    const result = await dataProvider.getList(resource, {
      ...params,
      pagination: { page, perPage },
    });
    records.push(...result.data);

    if (
      result.data.length === 0 ||
      (result.total != null && records.length >= result.total) ||
      result.pageInfo?.hasNextPage === false ||
      (result.total == null && result.pageInfo == null && result.data.length < perPage)
    ) {
      return records;
    }
    page += 1;
  }
};
